import { render, staticRenderFns } from "./RpcCategoryChart.vue?vue&type=template&id=2303f23a"
import script from "./RpcCategoryChart.vue?vue&type=script&lang=js"
export * from "./RpcCategoryChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports